module.exports = __webpack_public_path__ + "static/img/1.07272015.jpg";